





import calendar from "../../components/calendar.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
    components : {
        calendar
    },
})
export default class CalendarWrapper extends Vue{

    @Prop({}) calDirection:number;

    scope:string = null;

    mounted(){
        this.$emit('scope','calendar');
        this.checkScope();
        
    }

    checkScope(){
        if(!this.$route.params.scope){
            this.$route.params.scope = "daySelect";
            this.$route.params.calView = "1";
        }
        
        if(this.$route.params.scope == "daySelect"){
            this.$route.params.calView = "1";
        }else{
            this.$route.params.calView = "1";
        }

        this.scope = this.$route.params.scope;
    }

    catchCalUpdate(newCalObject){
        this.$emit("calStateChange", newCalObject)
    }

    @Watch('calDirection')
    updatedCalDirection(to,from){
    }

    @Watch('$route.params.scope')
    changeScope(to,from){
        this.checkScope();
    }
}
